import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { change } from 'redux-form';
import { Button } from 'react-bootstrap';

import messages from '../../../locale/messages';
import { closeHeaderModal } from '../../../actions/siteadmin/modalActions';

import bt from '../../commonStyle.css';


const ClearAll = ({ closeHeaderModal, resetForm }) => {

    const handleClick = () => {
        resetForm();
        closeHeaderModal('clearSubCategory')
    }
    return (
        <>
            <p className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor)}><FormattedMessage {...messages.clearAllContent} /></p>
            <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Button onClick={() => closeHeaderModal('clearSubCategory')} className={bt.btnSecondary}><FormattedMessage {...messages.cancelButton} /> </Button>
                <Button onClick={handleClick} className={bt.btnPrimary}><FormattedMessage {...messages.confirm} /> </Button>
            </div>
        </>
    )
}
const mapState = (state) => ({

});

const mapDispatch = {
    change,
    closeHeaderModal
};

export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(ClearAll)));